import { render, staticRenderFns } from "./Stage4.vue?vue&type=template&id=d4617a3c&"
import script from "./Stage4.vue?vue&type=script&lang=js&"
export * from "./Stage4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports